import store from './store/index';
import {CanceledError} from "axios";

export default {
  beforeDestroy() {
    this.abortAjax();
  },
  computed: {
    today() {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    sharedMessage() {
      return this.$store.getters.message;
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  watch: {
    sharedMessage: {
      async handler(message) {
        store.commit('initMessage')
        if (message) {
          await this.$bvModal.msgBoxOk(message, {
            title: 'Message',
            centered: true,
          });
        }
      }
    }
  },
  methods: {
    tenantId() {
      let user = store.getters['auth/currentUser'];
      return user ? user.tenant : null;
    },
    roles() {
      let user = store.getters['auth/currentUser'];
      return user ? user.roles : [];
    },
    hasAnyRole(...parms) {
      let roles = this.roles();
      return parms.some(parm => roles.includes(parm));
    },
    userName() {
      let user = store.getters['auth/currentUser'];
      return user ? user.userkorname : null;
    },
    currentUserId() {
      let user = store.getters['auth/currentUser'];
      return user ? user.caller : null;
    },
    pushRoute(path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(() => {
        });
      }
    },
    async showMessage(message) {
      return await this.$bvModal.msgBoxOk(message, {
        title: 'Message',
        centered: true,
      })
    },
    async showError(error) {
      if (error instanceof CanceledError) return;

      // In development environment, show the error
      if (process.env.NODE_ENV === 'development') {
        console.log('Error: ', error);
      }

      // For 401 Unauthorized, redirect to login page
      if (error.status === 401) {
        this.$store.commit('setMessage', error.message);
        this.pushRoute('/signin');
      } else {
        await this.showMessage(error.message);
      }
    },
    showConfirm(message) {
      return this.$bvModal.msgBoxConfirm(message, {
        title: 'Confirm',
        okVariant: 'primary',
        okTitle: 'YES',
        cancelTitle: 'NO',
        headerClass: 'detail-header',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      });
    },
    showMessageInToast(message) {
      this.$bvToast.toast(message, {
        title: `Notification`,
        toaster: "b-toaster-bottom-center",
        solid: true,
        appendToast: false,
        autoHideDelay: 2000
      })
    },
    showToast(message, variant = 'default', delay = 1000) {
      this.$bvToast.toast(`${message}`, {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: delay,
          variant: variant,
      })
    },
    showErrorsInToast() {
      for (const error of this.errors.items) {
        this.$bvToast.toast(error.msg, {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 2000,
          variant: "danger"
        });
      }
    },
    async validateForm() {
      const valid = await this.$validator.validate();
      if (!valid) {
        this.showErrorsInToast();
      }
      return valid;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    compareDates(d1, d2) {
      let date1 = new Date(d1).getTime();
      let date2 = new Date(d2).getTime();

      if (date1 < date2) {
        return -1;
      } else if (date1 > date2) {
        return 1;
      } else {
        return 0;
      }
    },
    formatNumber(val, minimumDigits = 2, maximumDigits = minimumDigits) {
      if (!Number(val)) return val;
      return Number(val).toLocaleString('ko-KR', {
        minimumFractionDigits: minimumDigits,
        maximumFractionDigits: maximumDigits
      })
    },
    compactFormatNumber(val) {
      return Intl.NumberFormat('en', {notation: 'compact'}).format(val);
    },
    refreshChart() {
      const chart = this.$refs.chart;
      if (chart) {
        chart.refresh();
      }
    },
    abortAjax() {
      if (this.abortController) {
        this.abortController.abort();
      }
    },
    formatFileSize(byte) {
      let fileSize = byte;
      // byte => kilobyte
      fileSize = Math.round(fileSize / 1024);

      if (fileSize < 1024) {
        return fileSize + ' KB'
      } else {
        return Math.round(fileSize / 1024) + ' MB';
      }
    },
  }
}